import React, { useMemo } from "react"
import commonIcon from "@/components/common/Icon/Icon"
import { getItemType, omit } from "@/utils/utils"
import { BUTTON_TYPE, CMS_ELEMENT_TYPENAME, CONTENT_TYPES, ICONS, MODAL_VARIANT } from "@/constants"
import dynamic from "next/dynamic"
import styled from "styled-components"

const Icon = styled(commonIcon)`
	svg {
		transition: rotate var(--rgr-duration) var(--ease);
		rotate: ${({ $rotation }) => `${$rotation || 0}deg`};
	}
`

const BUTTON_PROPS = {
	[CONTENT_TYPES.AUDIO_FILE]: {
		type: BUTTON_TYPE.UNSTYLED,
		modalVariant: MODAL_VARIANT.AUDIO,
		modalProps: {
			audioProps: {},
		},
		component: dynamic(() => import("@/components/common/Buttons/ModalButton"), { ssr: false }),
	},
	[CONTENT_TYPES.SINGLE_DOWNLOAD_FILE_BLOCK]: {
		type: BUTTON_TYPE.UNSTYLED,
		component: dynamic(() => import("@/components/common/Buttons/DownloadButton"), { ssr: false }),
	},
	[CONTENT_TYPES.EXTERNAL_LINK]: {
		type: BUTTON_TYPE.UNSTYLED,
		external: true,
		component: dynamic(() => import("@/components/common/Buttons/LinkButton"), { ssr: false }),
	},
	[CONTENT_TYPES.VIDEO]: {
		type: BUTTON_TYPE.UNSTYLED,
		modalVariant: MODAL_VARIANT.VIDEO,
		modalProps: {
			videoProps: {
				muted: false,
				playing: false,
				controls: true,
			},
		},
		component: dynamic(() => import("@/components/common/Buttons/ModalButton"), { ssr: false }),
	},
}

const omitList = [CMS_ELEMENT_TYPENAME, "fileVisibleName", "externalVideoUrl", "video", "source"]

function formatButtonProps(content) {
	const pressButtonType = getItemType(content)
	const baseProps = BUTTON_PROPS?.[pressButtonType] || BUTTON_PROPS[CONTENT_TYPES.AUDIO_FILE]
	const withoutSpareProps = omit(omitList, content)
	let typedProps = { ...withoutSpareProps, ...baseProps }
	switch (pressButtonType) {
		case CONTENT_TYPES.AUDIO_FILE:
			typedProps.modalProps.audioProps.url = content?.source?.url || ""
			typedProps.modalProps.audioProps.title = content?.source?.title || ""
			break
		case CONTENT_TYPES.VIDEO:
			typedProps.modalProps.videoProps.src = content?.externalVideoUrl?.url || content?.video?.url || ""
			break
		default:
			break
	}
	return typedProps
}

const PressButton = ({ data, rotation, children, ...props }) => {
	const { component: Button, ...buttonProps } = useMemo(() => {
		const content = data?.content || {}
		return formatButtonProps(content)
	}, [data])

	return (
		<Button {...props} {...buttonProps} noHoverEffect animation={false}>
			<Icon name={ICONS.ARROW_UP} color="white" $rotation={rotation} />
			{children}
		</Button>
	)
}

export default PressButton
